import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import ForumCardScreenshotButton from './ForumCardScreenshotButton';
import ForumAdminOnlyMeta, { type ForumAdminMetaFields } from './ForumAdminOnlyMeta';

interface Props {
  to: string;
  forumId: string;
  darkMode: boolean;
  className?: string;
  children: React.ReactNode;
  /** Tanıtım / admin çıkıntıları (yalnızca forumadmin) */
  adminMeta?: ForumAdminMetaFields | null;
}

const ForumCardWrapper: React.FC<Props> = ({
  to,
  forumId,
  darkMode,
  className = '',
  children,
  adminMeta = null,
}) => {
  const cardRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0">
      <div className="flex gap-2 items-center flex-1 min-w-0">
        <ForumCardScreenshotButton
          targetRef={cardRef}
          forumId={forumId}
          darkMode={darkMode}
          className="hidden md:flex shrink-0 self-center"
        />
        <Link to={to} className="flex-1 min-w-0 block">
          <div ref={cardRef} className={className}>
            {children}
          </div>
        </Link>
      </div>
      {adminMeta ? <ForumAdminOnlyMeta forum={adminMeta} darkMode={darkMode} /> : null}
    </div>
  );
};

export default ForumCardWrapper;
